/**
 * Defined services status
 */
export const ServicesStatusTypes = {
	ACTIVE: 1,
	ASSIGNED: 2,
	SUSPENDED: 3,
	WAITING: 4,
	COMPLETED: 5,
	REPLACED: 6,
	CANCELLED: 7
}

export const DELETED = 8
export const CHANGE_INITIATED_DATE = 9
export const ASSIGNED_SERVICE_PROVIDER_TECH = 10
export const CHANGE_REPRESENTATIVE_SALES = 11
export const REASSIGNED_SERVICE_PRIVIDER = 12

export const NOTIFICATION_SERVICE = 'Service'

/**Position for text box */
export const PositionPlacement = {
	END: 'end',
	START: 'start',
	TOP: 'top',
	BOTTOM: 'bottom'
}

export const UserTypes = {
	ACTIVE_DIRECTORY: 'InternalUser',
	NON_ACTIVE_DIRECTORY: 'ExternalUser'
}

/**
 * Defined type of roles
 */
export const RoleType = {
	UNDEFINED: 0,
	SERVICE_PROVIDER: 1,
	USER_IMBERA: 2,
	SALES_REPRESENTATIVE: 3,
	CUSTOMER: 4
}

export const AccountCode = {
	IMBERA: 'IMB'
}

/**
 * Defined type of failure warranty
 */
export const FailureWarrantyType = {
	REFRIGERATION_NOT_COOL: 1,
	ILUMINATION: 2,
	DOOR: 3
}

/**
 * Get position in pam default address (Imbera Food Service, Kennesaw, Georgia, EE. UU. )
 * latitude: 34.05732, longitude: -84.6088261
 */
export const PositionMapDefault = { latitude: 34.05732, longitude: -84.6088261, addresDefault: 'Imbera Food Service, Kennesaw, Georgia, EE. UU.' }

export const SpareParRequestStatus = {
	DRAFT: 1,
	IN_PROCESS: 2,
	SEND_TO_MX: 3,
	CLOSED: 4,
	DELETED: 5,
	CANCELLED: 6,
	SEND_TECH_USA: 7,
	REJECTED_RESEND: 8
}

export const WarehouseType = {
	MEXICO: 1,
	USA: 2
}

export const ServiceProviderStatus = {
	INVITATION_SEND: 1,
	SUPPLIER_ACCEPTED: 2,
	ACCEPTED_IN_COMPANY: 3,
	REJECTED_IN_COMPANY: 4
}

export const PaymentRequestStatus = {
	DRAFT: 1,
	IN_PROCESS: 2,
	REJECTED: 4,
	ACCEPTED: 5,
	CLOSED: 6
}

export const DELETED_PAYMENT = 3

/**
 * Get description amoutn type
 */
export const PaymentAmountType = {
	AmountLaboral: 'LABORAL',
	AmountMaterial: 'MATERIALS',
	AmountMileage: 'MILEAGE',
	AmountMiscellaneos: 'MISCELLANEOUS',
	AmountSales: 'SALES TX HST',
	AmountSale: 'SALES TXT HST',
	AmountTotal: 'TOTAL'
}

export const WarrantyType = {
	UNDEFINED: 0,
	WARRANTY: 1,
	SALE: 2
}

/**
 * Defined phases status
 */
export const PhaseType = {
	BACK_ORDER: 1,
	BACK_ORDER_PARTIAL: 2,
	CANCELLED: 3,
	CLOSED: 4,
	COMPLETED: 5,
	DIAGNOSTIC_REPORT: 6,
	DIAGNOSTIC_SERVICE_SCHEDULED: 7,
	DIAGNOSTIC_WAITING_TO_BE_SCHEDULED: 8,
	FOLLOW_UP: 9,
	INSTALL_PARTS_SCHEDULED: 10,
	INSTALL_PARTS_SCHEDULING: 11,
	NEW_SERVICE_TICKET: 12,
	ON_HOLD: 13,
	PARTS_PENDING_DELIVERY: 14,
	REPLACEMENT: 15,
	SERVICE_QUOTE: 16,
	SERVICED: 17,
	WAITING_FOR_CUSTOMER: 18,
	WAITING_FOR_SALES_REP: 19,
	WAITING_FOR_SERVICE_PROVIDER: 20,
	WAITING_ON_PARTS: 21
}

export const AccountType = {
	UNDEFINED: 0,
	REGISTERED_USER: 1,
	NON_REGISTERED_USER: 2
}

export const ChecklistQuestionType = {
	SINGLE_CHOICE: 1,
	MULTIPLE_CHOICE: 2,
	OPEN_ENDED: 3,
	RATING_SCALE: 4
}

/**
 * Work Process Status (independent of the official service Status)
 */
export const WorkProcessStatusTypes = {
	CALL_LATER: 1,
	CANCELLED: 2,
	CLOSED: 3,
	DISPATCHED: 4,
	ESCALATION: 5,
	ESCALATION_UPDATED: 6,
	PENDING_CONFIRMATION_OF_COMPLETION: 7,
	PENDING_ITSS: 8,
	PENDING_LOCAL_SP: 9,
	PENDING_PART_TO_DELIVER: 10,
	PENDING_SPR: 11,
	PENDING_TRACKING_INFORMATION: 12,
	REPLACED: 13,
	UPDATED: 14,
	UPDATING: 15,
	PENDING_TECHNICAL_MANAGER: 16
}
